module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_plan_show_bg_01-4dcdc1401e74777e186f8077e8e2952f.jpg";